import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles({
  root: {},
  mainContainer: {
    marginTop: 52,
  },
  sectionTitle: {
    fontSize: '20px',
    fontWeight: 600,
    marginBottom: '20px',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: '28px',
  },
  backButton: {
    color: STYLE.COLOR.ACCENT_PRIMARY,
    textDecoration: 'none',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 500,
    marginRight: '24px',
    lineHeight: '20px',
    padding: 0,
  },
  divider: {
    height: '1px',
    backgroundColor: '#EAEAEA',
    width: '100%',
    margin: '32px 0',
  },
  section: {
    marginTop: '32px',
  },
  halfWidth: {
    flex: '0 0 50%',
  },
});
